<tabs [tabs]="tabs"></tabs>
